import React, { Component } from 'react';
import { Container, Row, Col } from 'reactstrap';

export class Footer extends Component {
  static displayName = Footer.name;

  render() {
    return (
      <footer className="footer">
        <Container>
          <Row>
            <Col lg="4" md="6" className="mb-4">
              <h5>Iglesia CBR</h5>
              <p>
                Centro Bíblico Rodadero<br />
                "Jesucristo es la oportunidad de tu vida"
              </p>
              <div className="social-links">
                <a href="https://wa.me/573023772270" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-whatsapp"></i>
                </a>
                <a href="https://www.instagram.com/iglesiacbr" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-instagram"></i>
                </a>
                <a href="https://www.facebook.com/iglesiacbr" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-facebook"></i>
                </a>
                <a href="https://www.youtube.com/@iglesiacbr" target="_blank" rel="noopener noreferrer">
                  <i className="fab fa-youtube"></i>
                </a>
              </div>
            </Col>
            <Col lg="4" md="6" className="mb-4">
              <h5>Horarios</h5>
              <p>
                <strong>Domingos:</strong><br />
                7:00 AM, 9:00 AM, 11:00 AM<br />
                <strong>Miércoles:</strong><br />
                7:00 PM - Estudio Bíblico<br />
                <strong>Sábados:</strong><br />
                6:30 PM - Jóvenes
              </p>
            </Col>
            <Col lg="4" className="mb-4">
              <h5>Contacto</h5>
              <p>
                <i className="fas fa-map-marker-alt me-2"></i>
                Cra 4 #11a-38 Rodadero,<br />
                Magdalena, Colombia<br />
                <i className="fas fa-phone me-2"></i>
                +57 302 3772270<br />
                <i className="fas fa-envelope me-2"></i>
                info@iglesiacbr.org
              </p>
            </Col>
          </Row>
          <hr style={{ borderColor: 'var(--secondary-gold)' }} />
          <Row>
            <Col className="text-center">
              <p className="mb-0">
                &copy; 2025 Iglesia CBR - Centro Bíblico Rodadero. Todos los derechos reservados.
              </p>
            </Col>
          </Row>
        </Container>
      </footer>
    );
  }
}
